export default "__VITE_ASSET__886a1ef1__"